import runConfigService from "./runConfigService.js";

/**
 *
 * WaitingRoomService
 *
 * @namespace WaitingRoomService
 */
var WaitingRoomService = function(){
    'use strict';

    const domain = runConfigService.getEnvironmentCode() === 'prod' ? 'https://awsprod.nuskin.com' : 'https://awstest.nuskin.com',
        path = '/waiting-room/api/customer',
        ticketCookieName = 'ticketcookie';

    function checkTicketStatus(queue, secKey, callback) {
        let /*deferred = $.Deferred(),*/
            ticketCookie,
            resolved = false;

        secKey = secKey || '';
        ticketCookie = _getTicketCookie(queue, secKey);

        if (ticketCookie === null || _hasBeenEnoughTime(ticketCookie)) {
            let ticketNumber = 0;

            if (ticketCookie !== null && ticketCookie.id !== null) {
                ticketNumber = ticketCookie.id;
            }

            $.getJSON(_getTicketUrl(queue, ticketNumber), function(result) {
                console.log(result);
                resolved = true;
                _saveCookie(queue, result, secKey);
                callback(result);
                // deferred.resolve(result);
            });

        } else {
            resolved = true;
            callback(ticketCookie);
            // deferred.resolve(ticketCookie);
            // _processTicketCheck(ticketCookie);
        }

        setTimeout(function() {
            if (!resolved) {
                callback({queueStatus: 'timedOut'});
                // deferred.resolve('error');
            }
        }, 8000);

        // return deferred;
    }

    function checkQueueStatus(queue, callback) {
        let /*deferred = $.Deferred(),*/
            resolved = false;

        $.getJSON(_getWaitingRoomUrl(queue), function(result) {
            console.log(result);
            resolved = true;
            if (result.status === 'open') {
                callback('open');
                // deferred.resolve('open');
            } else {
                console.error('Invalid waiting room or not set to "open"', result);
                callback('notopen');
                // deferred.resolve('notopen');
            }
        });

        setTimeout(function() {
            if (!resolved) {
                callback('error');
                // deferred.resolve('error');
            }
        }, 12000);

        // return deferred;
    }

    function deleteTicket(queue, secKey) {
        let ticket = _getTicketCookie(queue, secKey);

        if (ticket !== null) {
            _deleteTicketById(queue, ticket.id);
        }
    }

    function _deleteTicketById(queue, id) {
        $.getJSON(_getDeleteTicketUrl(id));
        console.log("Ticket deleted: ", id);
        _deleteCookie(_getCookieName(queue));
    }

    function deleteAllQueueTickets() {
        let cookies = $.cookie();

        Object.keys(cookies).map(function(name) {
            if (name.substr(0, 'ticket_'.length) === 'ticket_') {
                try {
                    let ticket = JSON.parse(cookies[name]);
                    if (ticket.queueName) {
                        _deleteTicketById(ticket.queueName, ticket.id);
                    }
                } catch(e) {}

            }
            return -1;
        })
    }

    function _saveCookie(queue, data, secKey) {
        let date = new Date(),
            minutes = 15;

        data.secKey = secKey;
        data.lastCallTime = new Date().getTime();
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        $.cookie(_getCookieName(queue), JSON.stringify(data), { expires: date, path: '/' });
    }

    function _getWaitingRoomUrl(queue) {
        return domain + path + "/queue/" + queue + '?callback=?';
    }

    function _getCookieName(queue) {
        return 'ticket_' + queue;
    }

    function _getTicketCookie(queue, secKey) {
        let cookieName = _getCookieName(queue),
            cookieStr = $.cookie(cookieName),
            ticketCookie = cookieStr && cookieStr !== 'undefined' ? JSON.parse(cookieStr) : null;

        //Check to see if the quename for this page and the queue name in the cookie match if not then delete cookie
        if (ticketCookie !== null) {
            if (queue !== ticketCookie.queueName || ticketCookie.secKey !== secKey) {
                _deleteTicketById(queue, ticketCookie.id);
                ticketCookie = null;
            }
        }
        return ticketCookie;
    }

    function _deleteCookie(cookieName) {
        $.cookie(cookieName, null, {path: '/'});
    }

    function _hasBeenEnoughTime(cookie) {
        let reloadProtectionWaitTime = 15000,
            currentTime = new Date().getTime();

        return ((currentTime - reloadProtectionWaitTime) >= cookie.lastCallTime);
    }

    function _getTicketUrl(queue, ticketNumber) {
        return domain + path + '/' + queue + '/' + ticketNumber + '?callback=?';
    }

    function _getDeleteTicketUrl(ticketNumber) {
        return domain + path + '/delete/' + ticketNumber + '?callback=?';
    }

    return {
        checkQueueStatus: checkQueueStatus,
        checkTicketStatus: checkTicketStatus,
        deleteTicket: deleteTicket,
        deleteAllQueueTickets: deleteAllQueueTickets
    };
}();

export default WaitingRoomService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/waitingRoomService.js
// module id = 308
// module chunks = 0